import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PropertySet } from '@miq/domain/property-sets';
import { BehaviorSubject, map, Observable, take, tap } from 'rxjs';

export interface PropertySetLookupItem {
  [key: string]: string;
}

export interface PropertySetColumnState {
  propertySetsByUser$: Observable<PropertySetLookupItem>;
  fetchSetData(): void;
  cleanUp(): void;
}

@Injectable({ providedIn: 'root' })
export class PropertySetColumnStateService {
  #propertySetsByUser = new BehaviorSubject<PropertySetLookupItem>({});
  propertySetsByUser$ = this.#propertySetsByUser.asObservable();

  constructor(private client: HttpClient) {}

  fetchSetData(recordFilter?: { statisticalOnly: boolean }) {
    this.#getPropertySetByUser(recordFilter);
  }

  cleanUp() {
    this.#propertySetsByUser.next({});
  }

  getFlatValues() {
    return this.#propertySetsByUser.value;
  }

  #getPropertySetByUser(recordFilter?: { statisticalOnly: boolean }) {
    this.#fetchPropertySetByUser()
      .pipe(
        take(1),
        map(propertySets => this.#filterPropertySets(propertySets, recordFilter)),
        map(this.#createMap),
        tap(propertySets => this.#propertySetsByUser.next(propertySets))
      )
      .subscribe();
  }

  #filterPropertySets = (propertySets: PropertySet[], filter: { statisticalOnly: boolean }) => {
    if (filter?.statisticalOnly) {
      return propertySets.filter(ps => ps.is_statistical);
    }
    return propertySets;
  };

  #createMap = (psList: PropertySet[]) => {
    return psList.reduce((listMap, ps) => {
      listMap[ps.fingerprint] = ps.name;
      return listMap;
    }, {});
  };

  #fetchPropertySetByUser() {
    return this.client.get<PropertySet[]>('/api/propertysets');
  }
}
